var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fullwidth"},[_c('UHFSensorAccessoriesOverview'),_c('hr'),_c('CalibratorAccessoriesOverview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }